'use client';
import { BlocksRadioChangeEvent } from '@blocks-web-components/events';
import {
  useFormContext,
  useController,
  UseControllerProps
} from 'react-hook-form';

export const useRadioController = (
  props: UseControllerProps,
  callback?: (e: BlocksRadioChangeEvent) => void
) => {
  const { control } = useFormContext();
  const { field, fieldState, ...rest } = useController({ control, ...props });
  const isError = !!fieldState.error;
  const errorNote = fieldState.error?.message;
  const radioChange = (e: BlocksRadioChangeEvent) => {
    field.onChange(e);
    callback?.(e);
  };
  const getRadioField = (id = '', value = '') => {
    const checked = field.value === value;
    return { ...field, checked, onBlRadioChange: radioChange, id, value };
  };
  return {
    field,
    fieldState,
    getRadioField,
    radioFieldset: { errorNote, isError },
    ...rest
  };
};
